// export const api = "http://localhost:2003";
export const api = "https://stack-overflow-clone-48cn.onrender.com";
